import 'lightgallery.js';

export default class Lightgallery {
    static init() {
        document.addEventListener('click', (e) => {
            if (e.target.closest('.lightgallery') !== null) {
                let el = e.target.closest('.lightgallery');
                // destroy old instance
                if (window.lgData && el.getAttribute('lg-uid') in window.lgData) {
                    window.lgData[el.getAttribute('lg-uid')].destroy(true);
                }
                let elements = [],
                    group = el.getAttribute('data-lightgallery-group'),
                    index = 0;
                document
                    .querySelectorAll('[data-lightgallery-group="' + group + '"]')
                    .forEach((el2, key) => {
                        if (el === el2) {
                            index = key;
                        }
                        elements.push({
                            src: el2.getAttribute('href'),
                            thumb: el2.getAttribute('href')
                        });
                    });
                window.lightGallery(el, {
                    index: index,
                    dynamic: true,
                    dynamicEl: elements,
                    loop: true,
                    download: false,
                    counter: false
                });
                e.preventDefault();
            }
        });
    }
}
